import { render, staticRenderFns } from "./cover.vue?vue&type=template&id=b5799d1e&scoped=true"
import script from "./cover.vue?vue&type=script&lang=ts"
export * from "./cover.vue?vue&type=script&lang=ts"
import style0 from "./cover.vue?vue&type=style&index=0&id=b5799d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5799d1e",
  null
  
)

export default component.exports